import { render, staticRenderFns } from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=template&id=4994b273"
import script from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroResultadosAspiranteDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports